/**
 * Post-login return path (auth continuity).
 * Stash before loginRedirect / ProtectedRoute bounce; consume once after auth.
 * Rules mirrored in api/src/utils/authContinuity.js (eval SoT).
 */

export const AUTH_RETURN_TO_KEY = 'authReturnTo';

function isSafeAuthReturnTo(path: string): boolean {
  const target = path.trim();
  if (!target || target === '/' || !target.startsWith('/')) return false;
  if (target.startsWith('//')) return false;
  if (target.includes('\\')) return false;
  return true;
}

export function stashAuthReturnTo(path?: string | null) {
  if (typeof window === 'undefined') return;
  const target = (path || `${window.location.pathname}${window.location.search}`).trim();
  if (!isSafeAuthReturnTo(target)) return;
  // Avoid looping on marketing home
  sessionStorage.setItem(AUTH_RETURN_TO_KEY, target);
}

export function consumeAuthReturnTo(): string | null {
  if (typeof window === 'undefined') return null;
  const raw = sessionStorage.getItem(AUTH_RETURN_TO_KEY);
  sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
  if (!raw || !isSafeAuthReturnTo(raw)) return null;
  return raw.trim();
}
